import SuggestionForm from "../SuggestionForm/SuggestionForm.jsx";
import { useState } from "react";

function SuggestionWidget({ config }) {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showFamilyRoleRequired, setShowFamilyRoleRequired] = useState(false);
  const loginPopUp = document.getElementById("login-popup-wrapper");
  const renderMode = config.render_mode || "button";

  const has_role_permission =
    config.has_role_suggestions_permission.toLowerCase() === "true";
  const allow_anonymous =
    config.allow_anonymous_suggestions.toLowerCase() === "true";
  const isAnonymous = config.profile === "";
  const canSubmitAsAnonymous = isAnonymous && allow_anonymous;
  const canSubmitAsRegisteredUser = !isAnonymous && has_role_permission;
  const canSubmit = canSubmitAsAnonymous || canSubmitAsRegisteredUser;

  const handleOpenPopUp = () => {
    if (!has_role_permission) {
      //Si hay declarado un rol requerido chequea la condicion
      setShowFamilyRoleRequired(true);
    } else {
      setIsPopUpOpen(true);
    }
  };


  const showLoginPopUp = () => {
    if (loginPopUp) {
      const modal = new bootstrap.Modal(loginPopUp);
      modal.show();
    }
  };

  const handleClick = () => {
    if (isAnonymous && allow_anonymous) {
      setIsPopUpOpen(true);
    } else if (isAnonymous) {
      showLoginPopUp();
    } else {
      handleOpenPopUp();
    }
  };

  if (renderMode === "inline_form") {
    if (!canSubmit) {
      if (isAnonymous) {
        return (
          <div className="card p-4 shadow-sm w-100">
            <h3 className="h4">{config.translations.suggestionFormTitle}</h3>
            <button onClick={showLoginPopUp} className="btn btn-primary mt-3">
              {config.translations.suggestionTextBtn}
            </button>
          </div>
        );
      }

      return (
        <div className="card p-4 shadow-sm w-100">
          <h3 className="h4">{config.translations.suggestionFormTitle}</h3>
          <p className="text-danger mb-0 mt-2">
            {config.translations.suggestionErrorRole}
          </p>
        </div>
      );
    }

    return (
      <SuggestionForm
        show
        embedded
        onHide={() => {}}
        config={config}
      />
    );
  }

  return (
    <>
      <div className="card p-4 shadow-sm card-border-left w-100 min-height-16em d-flex flex-column align-items-start justify-content-center">
        <i className="fa-solid fa-pen-to-square text-primary fs-1 mb-4"></i>
        <h3 className="h4">{config.translations.suggestionTitle}</h3>
        <button
          onClick={handleClick}
          className="btn btn-primary mt-4"
        >
          <i className="fa-regular fa-lightbulb"></i>
          {config.translations.suggestionTextBtn}
        </button>
        <p className="SuggestionWidget_roleWarning">
          {showFamilyRoleRequired && config.translations.suggestionErrorRole}
        </p>
      </div>
      {isPopUpOpen && (
        <SuggestionForm
          onHide={() => setIsPopUpOpen(false)}
          show={isPopUpOpen}
          config={config}
        />
      )}
    </>
  );
}

export default SuggestionWidget;
